import { defineMessages } from 'react-intl';

export default defineMessages({
  selectAccount: {
    defaultMessage: 'Select Account',
    id: 'r1/Hct',
    description: 'Insights > Reports > Shipping Cost > Select Account',
  },
});
